<template>
  <div class="act-login">
    <div class="container">
      <div class="text-img">
        <img src="./imgs/login-text.png" />
      </div>
      <div class="form-wrapper">
        <div class="input-box">
          <input
            type="text"
            v-model="phoneNum"
            maxlength="11"
            onkeyup="this.value=this.value.replace(/\D/g,'')"
            onafterpaste="this.value=this.value.replace(/\D/g,'')"
            placeholder="请输入手机号码"
            @blur="checkPhone"
          />
        </div>
        <div class="input-box">
          <input
            maxlength="4"
            type="text"
            v-model="code"
            onkeyup="this.value=this.value.replace(/\D/g,'')"
            onafterpaste="this.value=this.value.replace(/\D/g,'')"
            placeholder="请输入验证码"
          />
          <span class="get-code" @click="getCode" v-if="verification"
            >获取验证码</span
          >
          <span class="get-code" v-else>{{ timer }}s后重新获取</span>
        </div>
        <div class="button-wrp" v-if="canLogin">
          <span class="btn" @click="login">注册</span>
        </div>
        <div class="button-wrp" v-else>
          <span class="btn no-login">注册</span>
        </div>
      </div>
      <div class="footer">
        <van-checkbox v-model="checked">
          <span class="text whi">我已阅读</span>
        </van-checkbox>
        <span class="text" @click="openRules(1)">《隐私协议》</span
        ><span class="text"></span>
        <span class="text" @click="openRules()">《用户协议》</span>
      </div>
    </div>
    <img class="bg" src="./imgs/login-bg.png" alt="" />
  </div>
</template>

<script>
import { Toast } from 'vant'
import { sendCode } from '@/api/index'
import { login } from '@/api/activity'
import { setUserTokenStorage } from '@/libs/token'
export default {
  name: 'act-login',
  data() {
    return {
      checked: false,
      verification: true,
      timer: 60,
      phoneNum: '',
      code: '',
      inviteSysUserId: '',
      inviteSource: '',
    }
  },
  computed: {
    canLogin() {
      if (!this.verification && this.code) {
        return true
      } else {
        return false
      }
    },
  },
  mounted() {
    this.inviteSysUserId = this.$route.query.inviteSysUserId
    this.inviteSource = this.$route.query.inviteSource
  },
  methods: {
    checkPhone() {
      if (!/^1[3456789]\d{9}$/.test(this.phoneNum)) {
        Toast('手机号码不合法，请重新输入')
        return false
      }
      return true
    },
    async getCode() {
      if (!this.checkPhone()) return
      let res = await sendCode({ phone: this.phoneNum })
      if (!res.code) {
        this.verification = false
        let auth_timer = setInterval(() => {
          this.timer--
          if (this.timer <= 0) {
            this.verification = true
            this.code = ''
            clearInterval(auth_timer)
          }
        }, 1000)
      }
    },
    async login() {
      if (!this.phoneNum) {
        Toast('手机号码不能为空')
        return
      }
      if (!this.code) {
        Toast('验证码不能为空')
        return
      }
      if (this.verification) {
        Toast('验证码到期，请重新获取')
        return
      }
      if (!this.checked) {
        Toast('请阅读并勾选相关协议')
        return
      }
      // jpushRegisterId
      let params = {
        phone: this.phoneNum,
        code: this.code,
        inviteId: Number(this.inviteSysUserId),
        inviteSource: Number(this.inviteSource),
      }
      let res = await login(params)
      if (!res.code) {
        setUserTokenStorage(res.data.token)
        this.$router.push(
          `/activity/complete?phone=${this.phoneNum}&inviteSource=${this.inviteSource}&inviteSysUserId=${this.inviteSysUserId}`
        )
      }
    },
    openRules(type) {
      let url = type
        ? 'https://protocol.imlaw.cn/lawyer_privacy_protocol.html?header=0'
        : 'https://protocol.imlaw.cn/lawyer_user_protocol.html?header=0'
      window.location.href = url
    },
  },
}
</script>

<style lang="scss" scoped>
.act-login {
  height: 100vh;
  position: relative;
  background: #3e22cd;
  // display: flex;
  // flex-direction: column;
  // justify-content: space-between;
  ::v-deep .van-icon {
    color: #111111;
  }
  .container {
    background: #fff;
    position: relative;
    height: 590px;
    z-index: 1;
    width: 312px;
    top: 80px;
    padding: 30px 20px;
    box-sizing: border-box;
    border-radius: 10px;
    box-shadow: 0px 4px 0px 0px rgba(30, 39, 125, 1);
    bottom: 50px;
    margin: 0 auto;
    // left: 50%;
    // transform: translateX(-50%);
    .text-img {
      text-align: center;
      img {
        width: 225px;
      }
    }
  }
  .form-wrapper {
    position: relative;
    z-index: 1;
    // width: 315px;
    margin: 0 auto;
    // top: 191px;
    margin-top: 33px;
    .input-box {
      position: relative;
      height: 65px;
      line-height: 65px;
      text-align: center;
      width: 100%;
      input {
        color: #111;
        width: 100%;
        border: 0;
        border-bottom: 1px solid rgba(183, 193, 248, 0.6);
        font-size: 16px;
        background: transparent;
      }
      .get-code {
        color: #d4b37d;
        position: absolute;
        right: 0;
        font-size: 16px;
      }
    }
    .button-wrp {
      margin-top: 48px;
      text-align: center;
      .btn {
        display: inline-block;
        width: 100%;
        height: 44px;
        line-height: 44px;
        color: #fff;
        // background: linear-gradient(253deg, #005bff 0%, #00dff1 100%);
        background: linear-gradient(270deg, #d4b37d 0%, #f1d09b 100%);
        border-radius: 22px;
      }
      .no-login {
        background: #c8c8c8;
        color: #e8ebff;
      }
    }
  }
  .footer {
    width: 100%;

    text-align: center;
    margin-top: 156px;
    display: flex;
    justify-content: center;
    .text {
      color: #d4b37d;
    }
    .whi {
      color: #999999;
    }
    ::v-deep .van-checkbox {
      .van-icon {
        font-size: 14px;
        color: #fff;
        background: #999;
      }
      .van-checkbox__icon--checked .van-icon {
        background: #d4b37d;
        border-color: #d4b37d;
      }
    }
  }
  .bg {
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }
}
</style>